import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=0fc41d36&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"
import style0 from "./audioPlayer.vue?vue&type=style&index=0&id=0fc41d36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc41d36",
  null
  
)

export default component.exports